import React, { useEffect, useState } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import $ from "jquery";
import ShowMoreText from "react-show-more-text";
import Chart from "react-apexcharts";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import mediaKit1 from "../../assets/media-kit-1.svg";
import mediaKit2 from "../../assets/media-kit-2.svg";
import mediaKit3 from "../../assets/media-kit-3.svg";
import shareFacebook from "../../assets/share-facebook.svg";
import shareInstagram from "../../assets/share-instagram.svg";
import shareWhatsupfrom from "../../assets/share-whatsup.svg";
import shareTwitter from "../../assets/share-twitter.svg";
import shareGmail from "../../assets/share-gmail.svg";
import ImageLoader from "../common/ImageLoader";
import { getCreatorKeyMetricsInfo, getCreatorProfileInfo, onCheckSocialAccounts } from '../../services';
import 'react-tabs/style/react-tabs.css';
import Close_black from "../../assets/close_black.svg";
import BackArrowWhite from "../../assets/back-arrow-white.svg";
import userImage from "../../assets/user-image.svg";
import socialIcon1 from "../../assets/insta-icon.svg";
import socialIcon2 from "../../assets/facebook-icon.svg";
import socialIcon3 from "../../assets/youtube-icon.svg";
import socialIcon4 from "../../assets/twitter-icon.svg";
import Profile_tooltip from "../../assets/tool-tip-mark.svg";
import shareIcon from "../../assets/share-icon.svg";
import footerLogo from "../../assets/josh-logo-footer.svg";
import pinMark from "../../assets/pin-mark.svg";
import imgNoData from "../../assets/not-data-image-2.svg";
import { codeConvert, constructName, duplicateValueMerge, encode, getYear, numberConversion, socialSection, socialSectionMetric, tagsConcat, viewPublisher2, viewPublisher3 } from '../../utils/common';
import { socialMediaColors } from '../../constants';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import IsLoadingHOC from '../HOC/loader/IsLoadingHOC';
import { useToast } from '../../toast';
import { EmailShareButton, FacebookShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share';
import { RWebShare } from 'react-web-share';
import _ from "lodash";

function SocialPerformance(props) {
    const { setLoading } = props;
    const [creatorDetail, setCreatorDetail] = useState([])
    const [newDetails, setNewDetails] = useState([]);
    const [details, setDetails] = useState({});
    const [series, setSeries] = useState([]);
    const [platformNames, setPlatformNames] = useState([]);
    const [platformColor, setPlatformColor] = useState([]);
    const [optionData, setOptionData] = useState([]);
    const [selectedOption, setSelectedOption] = useState([]);
    const [activeAudience, setActiveAudience] = useState(0);
    const [gender, setGender] = useState([50, 50]);
    const genderColor = ["#ed589d", "#9100eb"];
    const history = useHistory();
    const [age, setAge] = useState({
        title: [],
        value: [],
    });
    const [city, setCity] = useState({
        title: [],
        value: [],
    });
    const toast = useToast();
    const profileDetails = useSelector((state) => state.profileDetails)
    const [content, setContent] = useState({})
    const [showContent, setShowContent] = useState(false)

    useEffect(() => {
        $(document).ready(function ($) {
            $(".social-reports").removeClass("mobile-fixed");
            $(window).scroll(function () {
                var scroll = $(window).scrollTop();
                if (scroll >= 50) {
                    $(".social-reports").addClass("mobile-fixed");

                } else if (scroll <= 50) {
                    $(".social-reports").removeClass("mobile-fixed");
                }
            });
        });
    }, [])
    useEffect(() => {
        if (!profileDetails?.cp_creators?.[0]?.publisher_id) {
            return
        }
        setLoading(true)
        onCheckSocialAccounts().then((res) => {
            setShowContent(res.status)
        })
        getCreatorKeyMetricsInfo(profileDetails?.cp_creators?.[0]?.userName_id).then((response) => {
            setLoading(false)
            setContent(response)
            if (response.status) {
                $("#social-popup").modal("show")
                setCreatorDetail(response.data[0])
                const connections = response.data.filter(a => {
                    let type = a.type
                    return a[type].Network == "youtube" ||
                        a[type].Network == "facebook" ||
                        a[type].Network == "instagram" ||
                        a[type].Network == "twitter"
                })
                let contructData = []
                let data = [...connections]
                data.map(val => {
                    let type = val.type
                    const valueKey = val[type]
                    contructData = [...contructData, {
                        Network: valueKey.Network,
                        AccountTitle: valueKey.ChannelName || valueKey.NetworkUser,
                        NetworkUser: valueKey.NetworkUser,
                        Followers: valueKey.Followers || valueKey.TotalSubscribers,
                        TotalPosts: valueKey.SocialEngagement[0].PostsCountLifetime,
                        EngagementFind: {
                            ...valueKey.SocialEngagement[0],
                            Network: valueKey.Network,
                            NetworkUser: valueKey.NetworkUser,
                            VideoInformation: valueKey.VideoInformation,
                            TotalVideos: valueKey.TotalVideos || null,
                            AVV30: valueKey.AVV30 || null,
                            TotalComments: valueKey.TotalComments || null,
                            NumberOfPosts: valueKey.NumberOfPosts,
                            TotalViews: valueKey.TotalViews || null
                        }
                    }]
                })
                setNewDetails(contructData)
            }
        }).catch((err) => {
            console.log("err", err)
            setLoading(false)
        })
        getCreatorProfileInfo(profileDetails?.cp_creators?.[0]?.userName_id).then(async (response) => {
            setLoading(false)
            if (response.status) {
                const resp = await duplicateValueMerge(response.data);
                const accounts = resp[0]

                const connections = accounts.NewAccount.filter(
                    (a) =>
                        a.Network == "youtube" ||
                        a.Network == "facebook" ||
                        a.Network == "instagram" ||
                        a.Network == "twitter"
                );
                const engagement = accounts.Engagement;

                const newArray = [];

                for (let index = 0; index < connections.length; index++) {
                    const element = connections[index];
                    const engagementFind = engagement?.find(a => a.Network === element.Network && a.NetworkUser === element.NetworkUser);
                    let obj = {};

                    if (engagementFind) {
                        obj.engagementFind = engagementFind;
                        obj.engagementShow = true;
                    } else {
                        obj.engagementShow = false;
                    }

                    obj.Network = element.Network;
                    obj.AccountTitle = element.Title;
                    obj.AccountLogoURL = element.LogoURL;
                    obj.AccountNetworkUser = element.NetworkUser;
                    obj.AccountFollower = element.FollowersCount;
                    obj.Accounts = element.Accounts;
                    newArray.push(obj);
                }

                setDetails({ ...details, oldAccount: accounts, newAccount: newArray, actualAccount: accounts });

                let seriesCount = [];
                let tempColors = [];
                let tempPlatforms = [];
                for (let i = 0; i < accounts.Accounts.length; i++) {
                    seriesCount.push(accounts.Accounts[i].FollowersCount || 0);
                    tempColors.push(socialMediaColors[accounts.Accounts[i].key]);
                    tempPlatforms.push(accounts.Accounts[i].key);
                }
                setSeries(seriesCount);
                setPlatformColor(tempColors);
                setPlatformNames(tempPlatforms);
            }
        }).catch((err) => setLoading(false));
    }, [profileDetails])

    useEffect(() => {
        if (details?.actualAccount?.FlatAudience) {
            let name = Object.keys(details?.actualAccount.FlatAudience)[0];
            let tempOptions = [];
            Object.keys(details?.actualAccount.FlatAudience)
                .filter((item) => item != "TikTok")
                .filter((item) => item === "Instagram")
                .forEach((item, index) => {
                    let obj = {
                        value: item,
                        name: details?.actualAccount.FlagshipPropertyTitle
                    };
                    tempOptions.push(obj);
                });
            setSelectedOption(tempOptions[0]);
            setOptionData(tempOptions);
            updateValues(name);
        }
    }, [details?.actualAccount])

    const options = {
        noData: {
            text: "Data not Available",
            align: "center",
            verticalAlign: "middle",
            offsetX: 0,
            offsetY: 0,
            style: {
                color: "red",
                fontSize: "14px",
            },
        },
        fill: {
            colors: [function ({ value, seriesIndex, w }) {
                const account = details?.actualAccount?.Accounts.find(a => a.FollowersCount === value);
                if (account) {
                    return socialMediaColors[account.key];
                } else {
                    return '#D9534F'
                }
            }]
        },
        style: {
            backgroundColor: "red",
        },
        tooltip: {
            enabled: true,
            marker: {
                show: true,
                fill: {
                    colors: platformColor,
                },
            },
            fill: {
                colors: platformColor,
            },
            y: {
                formatter: function (value) {
                    let temp = numberConversion(value);
                    return temp;
                },
            },
        },

        labels: platformNames,
        plotOptions: {
            pie: {
                expandOnClick: true,
                donut: {
                    size: "50%",
                    labels: {
                        show: true,
                        name: {
                            // show: true,
                            offsetY: 15,
                            fontSize: "10px",
                            fontWeight: 200,
                            // fontFamily:"nano sans",
                            color: "#757575",
                            formatter: () => "Connections",
                        },
                        value: {
                            show: true,
                            fontSize: "14px",
                            // fontFamily: 'Nano Sans',
                            fontWeight: 600,
                            color: "white",
                            offsetY: -20,
                        },
                        total: {
                            show: true,
                            showAlways: true,
                            fontSize: "11px",
                            label: "Connections",
                            fontFamily: "Helvetica, Arial, sans-serif",
                            fontWeight: 600,
                            color: "white",
                            formatter: function (val) {
                                const addnumber = val.globals.series;
                                let sum = 0;
                                for (let i = 0; i < addnumber.length; i++) {
                                    sum = sum + addnumber[i];
                                }
                                return numberConversion(sum);
                            },
                        },
                        dataLabels: {
                            fill: {
                                colors: platformColor,
                            },
                        },
                    },
                },
            },
        },
        legend: {
            show: false,
            showForSingleSeries: false,
        },
    };
    const updateValues = (name) => {
        //--------target to get the array to get all the values---------
        let target = details?.actualAccount?.FlatAudience[name][0];
        //-------genderTarget to get the array to get data related to gender-------
        let genderTarget = target.Items.filter((item) => item.Type === "Sex")[0];
        // target.Items.filter((item) => item.Type === "Sex")[0].Item1.Value
        let genderPercentage = [...gender]
        Object.keys(genderTarget)?.map(b => {
            if ((b == "Item1" || b == "Item2")) {
                let val = genderTarget[b]
                if (val?.Title === "Female") {
                    genderPercentage[0] = genderTarget[b]?.Value
                } else if (val?.Title === "Male") {
                    genderPercentage[1] = genderTarget[b]?.Value
                }
            }
        })
        setGender(genderPercentage);
        //-------ageTarget to get the array to get data related to age-------
        let ageTarget = target.Items.filter(
            (item) => item.Type === "CombinedAge"
        )[0];
        // delete ageTarget.All;
        const constructObj = Object.values(ageTarget)?.filter(a => typeof a === "object" && a !== null)
        setAge({
            // ...age,
            value: [
                constructObj?.find((item) => item.Title === "< 18")?.Value,
                constructObj?.find((item) => item.Title === "18-24")?.Value,
                constructObj?.find((item) => item.Title === "25-34")?.Value,
                constructObj?.find((item) => item.Title === "35-44")?.Value,
                constructObj?.find((item) => item.Title === "45-64")?.Value,
                constructObj?.find((item) => item.Title === "65-")?.Value,
            ].filter(val => val !== undefined),
            title: [
                constructObj?.find((item) => item.Title === "< 18")?.Title,
                constructObj?.find((item) => item.Title === "18-24")?.Title,
                constructObj?.find((item) => item.Title === "25-34")?.Title,
                constructObj?.find((item) => item.Title === "35-44")?.Title,
                constructObj?.find((item) => item.Title === "45-64")?.Title,
                constructObj?.find((item) => item.Title === "65-")?.Title,
            ].filter(val => val !== undefined),
        });

        //-------flagsTarget to get the array to get data related to flags-------
        let flagTarget = target.Items.filter((item) => item.Type === "Countries")[0];
        let newFlag = [];
        for (let i = 1; i <= 5 && i <= Object.keys(flagTarget).length - 2; i++) {
            newFlag.push(flagTarget[`Item${i}`]);
        }
        setCity({
            value: newFlag.map(a => a.Value).filter(val => val !== undefined),
            title: newFlag.map(a => a.ShortName || a.Title).filter(val => val !== undefined),
        })
        setActiveAudience(
            details?.actualAccount?.FlatAudience["Instagram"]?.[0].Info.AudienceCredibility
        );
    };
    const series2 = [
        {
            name: "Age",
            data: age.value,
        },
    ];
    const options2 = {
        chart: {
            type: "bar",
            height: 350,
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "20%",
                endingShape: "rounded",
                borderRadius: 5,
            },
        },
        dataLabels: {
            enabled: false,

        },
        stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
        },
        xaxis: {
            categories: age.title,
        },
        yaxis: {
            labels: {
                formatter: (value) => {
                    return value + "%";
                },
            },
        },
        fill: {
            opacity: 1,
        },
        tooltip: {
            custom: function ({ series, seriesIndex, dataPointIndex }) {
                return (
                    '<div className="arrow_box p-2">' +
                    "<span><b>Age</b> " +
                    series[seriesIndex][dataPointIndex] +
                    "%</span>" +
                    "</div>"
                );
            },
        },
    };
    const genderOptions = {
        chart: {
            width: 600,
            type: "pie",
        },
        dataLabels: {
            enabled: true,
            offset: -40,
            style: {
                colors: ['#fff2cc'],
                textShadow: false,
                textOutline: false,
            },
            dropShadow: {
                enabled: false,
            },
            // minAngleToShowLabel: 25
            background: {
                enabled: true,
                foreColor: '#000',
                borderRadius: 2,
                padding: 4,
                dropShadow: 'false',
            },

        },
        tooltip: {
            enabled: false
        },
        colors: genderColor,
        labels: ["Female", "Male"],
        legend: {
            show: true,
            position: "bottom",
            marker: {
                colors: genderColor,
            },
        },
    };
    const series3 = [
        {
            name: "Countries",
            data: city.value,
        },
    ];
    const options3 = {
        chart: {
            type: "bar",
            height: 350,
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "40%",
                endingShape: "rounded",
                borderRadius: 4,
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
        },
        xaxis: {
            categories: city.title,
        },
        yaxis: {
            labels: {
                formatter: (value) => {
                    return value + "%";
                },
            },
        },
        fill: {
            opacity: 1,
        },
        tooltip: {
            custom: function ({ series, seriesIndex, dataPointIndex }) {
                return (
                    '<div className="arrow_box p-2">' +
                    "<span><b>City</b> " +
                    series[seriesIndex][dataPointIndex] +
                    "%</span>" +
                    "</div>"
                );
            },
        },
    };

    const firstHeadingTitle = (network) => {
        switch (network) {
            case "instagram":
                return {
                    heading: (
                        <p>
                            Total <br />
                            Followers
                        </p>
                    ),
                };
            case "youtube":
                return {
                    heading: (
                        <p>
                            Subscribes <br />{" "}
                        </p>
                    ),
                };
            case "facebook":
                return {
                    heading: (
                        <p>
                            Page <br />
                            Likes
                        </p>
                    ),
                };
            case "twitter":
                return {
                    heading: (
                        <p>
                            Followers <br />{" "}
                        </p>
                    ),
                };
        }
    };

    const engagementSection = (account) => {
        const socialPriority = (network, keyValue) => {
            if (account?.[`${keyValue}90Days`]) {
                return "90Days";
            }
            if (account?.[`${keyValue}60Days`]) {
                return "60Days";
            }
            if (account?.[`${keyValue}30Days`]) {
                return "30Days";
            }
            if (account?.[`${keyValue}20Posts`]) {
                return "20Posts";
            }
            if (account?.[`${keyValue}Lifetime`]) {
                return "Life time"
            }
            if (account?.[`${keyValue}90`]) {
                return "90Days";
            }
            if (account?.[`${keyValue}60`]) {
                return "60Days";
            }
            if (account?.[`${keyValue}30`]) {
                return "30Days";
            }
        };
        const engagementPriority = (value, type) => {
            if (value === "90Days") {
                return type === "number"
                    ? (account?.EngagementRate90Days * 100).toFixed(2)
                    : "90 days";
            } else if (value === "60Days") {
                return type === "number"
                    ? (account?.EngagementRate60Days * 100).toFixed(2)
                    : "60 days";
            } else if (value === "30Days") {
                return type === "number"
                    ? (account?.EngagementRate30Days * 100).toFixed(2)
                    : "30 days";
            } else if (value === "20Posts") {
                return type === "number"
                    ? (account?.EngagementRate20Posts * 100).toFixed(2)
                    : "20 posts";
            } else if (value === "Life time") {
                return type === "number"
                    ? (account?.EngagementRateLifetime * 100).toFixed(2)
                    : "20 posts";
            }
        };

        const likesPerPostPriority = (value, type) => {
            if (value === "90Days") {
                return type === "number"
                    ? account?.LikesPerPost90Days.toFixed(2)
                    : "90 days";
            } else if (value === "60Days") {
                return type === "number"
                    ? account?.LikesPerPost60Days.toFixed(2)
                    : "60 days";
            } else if (value === "30Days") {
                return type === "number"
                    ? account?.LikesPerPost30Days.toFixed(2)
                    : "30 days";
            } else if (value === "20Posts") {
                return type === "number"
                    ? account?.LikesPerPost20Posts.toFixed(2)
                    : "20 post";
            } else if (value === "Life time") {
                return type === "number"
                    ? account?.LikesPerPostLifetime.toFixed(2)
                    : "Life time";
            }
        };

        const commentsPerPostPriority = (value, type) => {
            if (value === "90Days") {
                return type === "number"
                    ? account?.CommentsPerPost90Days.toFixed(2)
                    : "90 days";
            } else if (value === "60Days") {
                return type === "number"
                    ? account?.CommentsPerPost60Days.toFixed(2)
                    : "60 days";
            } else if (value === "30Days") {
                return type === "number"
                    ? account?.CommentsPerPost30Days.toFixed(2)
                    : "30 days";
            } else if (value === "20Posts") {
                return type === "number"
                    ? account?.CommentsPerPost20Posts.toFixed(2)
                    : "20 post";
            } else if (value === "Life time") {
                return type === "number"
                    ? account?.CommentsPerPostLifetime.toFixed(2)
                    : "Life time";
            }
        };

        const sharesPerPostPriority = (value, type) => {
            if (value === "90Days") {
                return type === "number"
                    ? account?.SharesPerPost90Days.toFixed(2)
                    : "90 days";
            } else if (value === "60Days") {
                return type === "number"
                    ? account?.SharesPerPost60Days.toFixed(2)
                    : "60 days";
            } else if (value === "30Days") {
                return type === "number"
                    ? account?.SharesPerPost30Days.toFixed(2)
                    : "30 days";
            } else if (value === "20Posts") {
                return type === "number"
                    ? account?.SharesPerPost20Posts.toFixed(2)
                    : "20 post";
            } else if (value === "Life time") {
                return type === "number"
                    ? account?.SharesPerPostLifetime.toFixed(2)
                    : "Life time";
            }
        };

        const viewsPerPostPriority = (value, type) => {
            if (value === "90Days") {
                return type === "number"
                    ? account?.ViewsPerPost90Days.toFixed(2)
                    : "90 days";
            } else if (value === "60Days") {
                return type === "number"
                    ? account?.ViewsPerPost60Days.toFixed(2)
                    : "60 days";
            } else if (value === "30Days") {
                return type === "number"
                    ? account?.ViewsPerPost30Days.toFixed(2)
                    : "30 days";
            } else if (value === "20Posts") {
                return type === "number"
                    ? account?.ViewsPerPost20Posts.toFixed(2)
                    : "20 post";
            } else if (value === "Life time") {
                return type === "number"
                    ? account?.ViewsPerPostLifetime.toFixed(2)
                    : "Life time";
            }
        };

        const avgMonthlyViews = (value, type) => {
            if (value === "90Days") {
                return type === "number"
                    ? account?.AVV90?.toFixed(2)
                    : "90 days";
            } else if (value === "60Days") {
                return type === "number"
                    ? account?.AVV60?.toFixed(2)
                    : "60 days";
            } else if (value === "30Days") {
                return type === "number"
                    ? account?.AVV30?.toFixed(2)
                    : "30 days";
            }
        };

        const headingSection1 = () => {
            switch (account?.Network) {
                case "instagram":
                    return {
                        heading: (
                            <p>
                                Total <br />
                                Post
                            </p>
                        ),
                        tooltip: null,
                        subheading: numberConversion(account?.NumberOfPosts) || "N/A",
                    };
                case "twitter":
                    return {
                        heading: (
                            <p>
                                Total <br />
                                Tweets
                            </p>
                        ),
                        tooltip: null,
                        subheading: numberConversion(account?.NumberOfPosts) || "N/A",
                    };
                case "youtube":
                    return {
                        heading: (
                            <p>
                                Total <br />
                                Views
                            </p>
                        ),
                        tooltip: null,
                        subheading:
                            numberConversion(account?.TotalViews, "number") || "N/A",
                    };
                case "facebook":
                    return {
                        heading: (
                            <p>
                                Engagement <br />
                                Rate
                            </p>
                        ),
                        tooltip: socialPriority(account.Network, "EngagementRate") ? (

                            <div className="key-metric-tooltip">
                                <img
                                    aria-expanded="false"
                                    aria-hidden="true"
                                    id="metric-dropdown"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    src={Profile_tooltip}
                                    alt=""
                                />
                                <div className="right_tooltip">
                                    <div
                                        className="dropdown-menu  dropdown-toggle"
                                        aria-labelledby="metric-dropdown"
                                    >
                                        <a href="javascript:void(0);">
                                            [Based on last] {" "}
                                            {engagementPriority(
                                                socialPriority(account.Network, "EngagementRate"),
                                                "text"
                                            )}
                                        </a>
                                    </div>
                                </div>
                            </div>

                        ) : null,
                        subheading: `${socialPriority(account.Network, "EngagementRate") ? `${numberConversion(
                            engagementPriority(socialPriority(account.Network, "EngagementRate"), "number") || "N/A"
                        )} %` : "N/A"}`,
                    };
            }
        };

        const headingSection2 = () => {
            switch (account?.Network) {
                case "instagram":
                    return {
                        heading: (
                            <p>
                                Engagement <br />
                                Rate
                            </p>
                        ),
                        tooltip: socialPriority(account.Network, "EngagementRate") ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {engagementPriority(socialPriority(account.Network, "EngagementRate"), "text")}
                            </a>
                        ) : null,
                        subheading: `${socialPriority(account.Network, "EngagementRate") ? `${numberConversion(
                            engagementPriority(socialPriority(account.Network, "EngagementRate"), "number") || 0
                        )} %` : "N/A"}`,
                    };
                case "twitter":
                    return {
                        heading: (
                            <p>
                                Engagement <br />
                                Rate
                            </p>
                        ),
                        tooltip: socialPriority(account.Network, "EngagementRate") ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {engagementPriority(socialPriority(account.Network, "EngagementRate"), "text")}
                            </a>
                        ) : null,
                        subheading: `${socialPriority(account.Network, "EngagementRate") ? `${numberConversion(
                            engagementPriority(socialPriority(account.Network, "EngagementRate"), "number") || 0
                        )} %` : "N/A"} `,
                    };
                case "youtube":
                    return {
                        heading: (
                            <p>
                                Engagement <br />
                                Rate
                            </p>
                        ),
                        tooltip: socialPriority(account.Network, "EngagementRate") ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {engagementPriority(socialPriority(account.Network, "EngagementRate"), "text")}
                            </a>
                        ) : null,
                        subheading: `${socialPriority(account.Network, "EngagementRate") ? `${numberConversion(
                            engagementPriority(socialPriority(account.Network, "EngagementRate"), "number") || 0
                        )} %` : "N/A"}`,
                    };
                case "facebook":
                    return {
                        heading: (
                            <p>
                                Like <br />
                                Per Post
                            </p>
                        ),
                        tooltip: numberConversion(
                            likesPerPostPriority(socialPriority(account.Network, "LikesPerPost"), "number")
                        ) ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {likesPerPostPriority(socialPriority(account.Network, "LikesPerPost"), "text")}
                            </a>
                        ) : null,
                        subheading:
                            numberConversion(
                                likesPerPostPriority(socialPriority(account.Network, "LikesPerPost"), "number")
                            ) || "N/A",
                    };
            }
        };
        const headingSection3 = () => {
            switch (account?.Network) {
                case "instagram":
                    return {
                        heading: (
                            <p>
                                Likes <br />
                                Per Post
                            </p>
                        ),
                        tooltip: numberConversion(
                            likesPerPostPriority(socialPriority(account.Network, "LikesPerPost"), "number")
                        ) ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {likesPerPostPriority(socialPriority(account.Network, "LikesPerPost"), "text")}
                            </a>
                        ) : null,
                        subheading:
                            numberConversion(
                                likesPerPostPriority(socialPriority(account.Network, "LikesPerPost"), "number")
                            ) || "N/A",
                    };
                case "twitter":
                    return {
                        heading: (
                            <p>
                                Favourites <br />
                                per tweet
                            </p>
                        ),
                        tooltip: numberConversion(
                            likesPerPostPriority(socialPriority(account.Network, "LikesPerPost"), "number")
                        ) ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {likesPerPostPriority(socialPriority(account.Network, "LikesPerPost"), "text")}
                            </a>
                        ) : null,
                        subheading:
                            numberConversion(
                                likesPerPostPriority(socialPriority(account.Network, "LikesPerPost"), "number")
                            ) || "N/A",
                    };
                case "youtube":
                    return {
                        heading: (
                            <p>
                                Views <br />
                                per video
                            </p>
                        ),
                        tooltip: numberConversion(
                            viewsPerPostPriority(socialPriority(account.Network, "ViewsPerPost"), "number") ||
                            0
                        ) ? (
                            <a href="javascript:void(0);">
                                [Based on last]
                                {viewsPerPostPriority(socialPriority(account.Network, "ViewsPerPost"), "text")}
                            </a>
                        ) : null,
                        subheading: numberConversion(
                            viewsPerPostPriority(socialPriority(account.Network, "ViewsPerPost"), "number") ||
                            0
                        ) || "N/A",
                    };
                case "facebook":
                    return {
                        heading: (
                            <p>
                                Comments <br />
                                per post
                            </p>
                        ),
                        tooltip: numberConversion(
                            commentsPerPostPriority(
                                socialPriority(account.Network, "CommentsPerPost"),
                                "number"
                            )
                        ) ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {commentsPerPostPriority(
                                    socialPriority(account.Network, "CommentsPerPost"),
                                    "text"
                                )}
                            </a>
                        ) : null,
                        subheading: numberConversion(
                            commentsPerPostPriority(
                                socialPriority(account.Network, "CommentsPerPost"),
                                "number"
                            )
                        ) || "N/A",
                    };
            }
        };
        const headingSection4 = () => {
            switch (account?.Network) {
                case "instagram":
                    return {
                        heading: (
                            <p>
                                Comments <br />
                                per post
                            </p>
                        ),
                        tooltip: numberConversion(
                            commentsPerPostPriority(
                                socialPriority(account.Network, "CommentsPerPost"),
                                "number"
                            )
                        ) ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {commentsPerPostPriority(
                                    socialPriority(account.Network, "CommentsPerPost"),
                                    "text"
                                )}
                            </a>
                        ) : null,
                        subheading: numberConversion(
                            commentsPerPostPriority(
                                socialPriority(account.Network, "CommentsPerPost"),
                                "number"
                            )
                        ) || "N/A",
                    };
                case "twitter":
                    return {
                        heading: (
                            <p>
                                Retweet <br />
                                per tweet
                            </p>
                        ),
                        tooltip: numberConversion(
                            sharesPerPostPriority(
                                socialPriority(account.Network, "SharesPerPost"),
                                "number"
                            )
                        ) ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {sharesPerPostPriority(socialPriority(account.Network, "SharesPerPost"), "text")}
                            </a>
                        ) : null,
                        subheading: numberConversion(
                            sharesPerPostPriority(
                                socialPriority(account.Network, "SharesPerPost"),
                                "number"
                            )
                        ) || "N/A",
                    };
                case "youtube":
                    return {
                        heading: (
                            <p>
                                Likes <br />
                                per video
                            </p>
                        ),
                        tooltip: numberConversion(
                            likesPerPostPriority(socialPriority(account.Network, "LikesPerPost"), "number")
                        ) ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {likesPerPostPriority(socialPriority(account.Network, "LikesPerPost"), "text")}
                            </a>
                        ) : null,
                        subheading:
                            numberConversion(
                                likesPerPostPriority(socialPriority(account.Network, "LikesPerPost"), "number")
                            ) || "N/A",
                    };
                case "facebook":
                    return {
                        heading: (
                            <p>
                                Shares <br />
                                per post
                            </p>
                        ),
                        tooltip: numberConversion(
                            sharesPerPostPriority(
                                socialPriority(account.Network, "SharesPerPost"),
                                "number"
                            )
                        ) ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {sharesPerPostPriority(socialPriority(account.Network, "SharesPerPost"), "text")}
                            </a>
                        ) : null,
                        subheading: numberConversion(
                            sharesPerPostPriority(
                                socialPriority(account.Network, "SharesPerPost"),
                                "number"
                            )
                        ) || "N/A",
                    };
            }
        };
        const headingSection5 = () => {
            switch (account?.Network) {
                case "instagram":
                    return {
                        heading: (
                            <p>
                                Total <br />  Video
                            </p>
                        ),
                        tooltip: null,
                        subheading: account?.VideoInformation?.TotalVideos ? numberConversion(account?.VideoInformation?.TotalVideos) : "N/A",
                    };
                case "twitter":
                    return {
                        heading: null,
                        tooltip: null,
                        subheading: null,
                    };
                case "youtube":
                    return {
                        heading: (
                            <p>
                                Comments <br /> Per Video
                            </p>
                        ),
                        tooltip: numberConversion(
                            commentsPerPostPriority(socialPriority(account.Network, "CommentsPerPost"), "number")
                        ) ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {commentsPerPostPriority(socialPriority(account.Network, "CommentsPerPost"), "text")}
                            </a>
                        ) : null,
                        subheading:
                            numberConversion(
                                commentsPerPostPriority(socialPriority(account.Network, "CommentsPerPost"), "number")
                            ) || "N/A",
                    };
                case "facebook":
                    return {
                        heading: (
                            <p>
                                Talking <br />
                                About
                            </p>
                        ),
                        tooltip: null,
                        subheading: account?.TotalComments ? numberConversion(account?.TotalComments) : "N/A",
                    };
            }
        };

        const headingSection6 = () => {
            switch (account?.Network) {
                case "instagram":
                    return {
                        heading: (
                            <p>
                                Total <br /> Views
                            </p>
                        ),
                        tooltip: null,
                        subheading: account?.VideoInformation?.TotalViews ? numberConversion(account?.VideoInformation?.TotalViews) : "N/A",
                    };
                case "twitter":
                    return {
                        heading: null,
                        tooltip: null,
                        subheading: null,
                    };
                case "youtube":
                    return {
                        heading: (
                            <p>
                                Total <br /> Video
                            </p>
                        ),
                        tooltip: null,
                        subheading: account?.TotalVideos ? numberConversion(account?.TotalVideos) : "N/A",
                    };
                case "facebook":
                    return {
                        heading: null,
                        tooltip: null,
                        subheading: null,
                    };
            }
        };

        const headingSection7 = () => {
            switch (account?.Network) {
                case "instagram":
                    return {
                        heading: (
                            <p>
                                Views<br />
                                Per Video
                            </p>
                        ),
                        tooltip: null,
                        subheading: account?.VideoInformation?.AvgLastViewsPerVideo ? numberConversion(account?.VideoInformation?.AvgLastViewsPerVideo) : "N/A",
                    };
                case "twitter":
                    return {
                        heading: null,
                        tooltip: null,
                        subheading: null,
                    };
                case "youtube":
                    return {
                        heading: (
                            <p>
                                Avg<br />
                                Monthly Views
                            </p>
                        ),
                        tooltip: numberConversion(
                            avgMonthlyViews(socialPriority(account.Network, "AVV"), "number")
                        ) ? (
                            <a href="javascript:void(0);">
                                [Based on last] {" "}
                                {avgMonthlyViews(socialPriority(account.Network, "AVV"), "text")}
                            </a>
                        ) : null,
                        subheading: numberConversion(
                            avgMonthlyViews(socialPriority(account.Network, "AVV"), "number")
                        ) || "N/A",
                    };
                case "facebook":
                    return {
                        heading: null,
                        tooltip: null,
                        subheading: null,
                    };
            }
        };
        const headingSection8 = () => {
            switch (account?.Network) {
                case "instagram":
                    return {
                        heading: (
                            <p>
                                Likes<br />
                                Per Video
                            </p>
                        ),
                        tooltip: null,
                        subheading: account?.VideoInformation?.AvgLastLikesPerVideo ? numberConversion(account?.VideoInformation?.AvgLastLikesPerVideo) : "N/A",
                    };
                case "twitter":
                    return {
                        heading: null,
                        tooltip: null,
                        subheading: null,
                    };
                case "youtube":
                    return {
                        heading: null,
                        tooltip: null,
                        subheading: null,
                    };
                case "facebook":
                    return {
                        heading: null,
                        tooltip: null,
                        subheading: null,
                    };
            }
        };
        const headingSection9 = () => {
            switch (account?.Network) {
                case "instagram":
                    return {
                        heading: (
                            <p>
                                Comments<br />
                                Per Video
                            </p>
                        ),
                        tooltip: null,
                        subheading: account?.VideoInformation?.AvgLastCommentsPerVideo ? numberConversion(account?.VideoInformation?.AvgLastCommentsPerVideo) : "N/A",
                    };
                case "twitter":
                    return {
                        heading: null,
                        tooltip: null,
                        subheading: null,
                    };
                case "youtube":
                    return {
                        heading: null,
                        tooltip: null,
                        subheading: null,
                    };
                case "facebook":
                    return {
                        heading: null,
                        tooltip: null,
                        subheading: null,
                    };
            }
        };
        return (
            <>

                <div className="key-metric-card">
                    {headingSection1().heading}
                    {headingSection1().tooltip}
                    <b>{headingSection1().subheading}</b>
                </div>
                <div className="key-metric-card">


                    {headingSection2(account).heading}
                    {headingSection2(account).tooltip && <div className="key-metric-tooltip">
                        <img
                            aria-expanded="false"
                            aria-hidden="true"
                            id="metric-dropdown"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            src={Profile_tooltip}
                            alt=""
                        />
                        <div className="right_tooltip">
                            <div
                                className="dropdown-menu  dropdown-toggle"
                                aria-labelledby="metric-dropdown"
                            >
                                {headingSection2(account).tooltip}
                            </div>
                        </div>
                    </div>}
                    <b>{headingSection2(account).subheading}</b>
                </div>
                <div className="key-metric-card">


                    {headingSection3(account).heading}
                    {headingSection3(account).tooltip && <div className="key-metric-tooltip">
                        <img
                            aria-expanded="false"
                            aria-hidden="true"
                            id="metric-dropdown"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            src={Profile_tooltip}
                            alt=""
                        />
                        <div className="right_tooltip">
                            <div
                                className="dropdown-menu  dropdown-toggle"
                                aria-labelledby="metric-dropdown"
                            >
                                {headingSection3(account).tooltip}
                            </div>
                        </div>
                    </div>}
                    <b>{headingSection3(account).subheading}</b>
                </div>
                <div className="key-metric-card">


                    {headingSection4(account).heading}
                    {headingSection4(account).tooltip && <div className="key-metric-tooltip">
                        <img
                            aria-expanded="false"
                            aria-hidden="true"
                            id="metric-dropdown"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            src={Profile_tooltip}
                            alt=""
                        />
                        <div className="right_tooltip">
                            <div
                                className="dropdown-menu  dropdown-toggle"
                                aria-labelledby="metric-dropdown"
                            >
                                {headingSection4(account).tooltip}
                            </div>
                        </div>
                    </div>}
                    <b>{headingSection4(account).subheading}</b>
                </div>
                {headingSection5(account).heading && <div className="key-metric-card">
                    {headingSection5(account).heading}
                    {headingSection5(account).tooltip &&
                        <div className="key-metric-tooltip">
                            <img
                                aria-expanded="false"
                                aria-hidden="true"
                                id="metric-dropdown"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                src={Profile_tooltip}
                                alt=""
                            />
                            <div className="right_tooltip">
                                <div
                                    className="dropdown-menu  dropdown-toggle"
                                    aria-labelledby="metric-dropdown"
                                >
                                    {headingSection5(account).tooltip}
                                </div>
                            </div>
                        </div>
                    }
                    <b>{headingSection5(account).subheading}</b>
                </div>}
                {headingSection6(account).heading && <div className="key-metric-card">
                    {headingSection6(account).heading}
                    {headingSection6(account).tooltip &&
                        <div className="key-metric-tooltip">
                            <img
                                aria-expanded="false"
                                aria-hidden="true"
                                id="metric-dropdown"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                src={Profile_tooltip}
                                alt=""
                            />
                            <div className="right_tooltip">
                                <div
                                    className="dropdown-menu  dropdown-toggle"
                                    aria-labelledby="metric-dropdown"
                                >
                                    {headingSection6(account).tooltip}
                                </div>
                            </div>
                        </div>
                    }
                    <b>{headingSection6(account).subheading}</b>
                </div>}
                {headingSection7(account).heading && <div className="key-metric-card">
                    {headingSection7(account).heading}
                    {headingSection7(account).tooltip &&
                        <div className="key-metric-tooltip">
                            <img
                                aria-expanded="false"
                                aria-hidden="true"
                                id="metric-dropdown"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                src={Profile_tooltip}
                                alt=""
                            />
                            <div className="right_tooltip">
                                <div
                                    className="dropdown-menu  dropdown-toggle"
                                    aria-labelledby="metric-dropdown"
                                >
                                    {headingSection7(account).tooltip}
                                </div>
                            </div>

                        </div>}
                    <b>{headingSection7(account).subheading}</b>
                </div>}
                {headingSection8(account).heading && <div className="key-metric-card">
                    {headingSection8(account).heading}
                    {headingSection8(account).tooltip &&
                        <div className="key-metric-tooltip">
                            <img
                                aria-expanded="false"
                                aria-hidden="true"
                                id="metric-dropdown"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                src={Profile_tooltip}
                                alt=""
                            />
                            <div className="right_tooltip">
                                <div
                                    className="dropdown-menu  dropdown-toggle"
                                    aria-labelledby="metric-dropdown"
                                >
                                    {headingSection8(account).tooltip}
                                </div>
                            </div>

                        </div>}
                    <b>{headingSection8(account).subheading}</b>
                </div>}
                {headingSection9(account).heading && <div className="key-metric-card">
                    {headingSection9(account).heading}
                    {headingSection9(account).tooltip &&
                        <div className="key-metric-tooltip">
                            <img
                                aria-expanded="false"
                                aria-hidden="true"
                                id="metric-dropdown"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                src={Profile_tooltip}
                                alt=""
                            />
                            <div className="right_tooltip">
                                <div
                                    className="dropdown-menu  dropdown-toggle"
                                    aria-labelledby="metric-dropdown"
                                >
                                    {headingSection9(account).tooltip}
                                </div>
                            </div>
                        </div>
                    }
                    <b>{headingSection9(account).subheading}</b>
                </div>}
            </>
        );
    };
    const onGoBack = () => {
        $("#social-popup").modal("hide")
        history.goBack()
    }

    const onCopyLink = () => {
        navigator.clipboard.writeText(`${window.location.origin}/media-kit/${profileDetails?.cp_creators?.[0]?.userName_id}`);
        toast.open("Link copied successfully");
    }
    if (!content?.status) {
        return <p className="showText">{content?.message}</p>
    }
    return (
        <>
            <div className='social-performance-wrap social-reports'>
                {/* Social Performance Popup Start Here */}
                <div
                    className="modal fade show"
                    tabIndex="-1"
                    aria-labelledby="exampleModalLabel"
                    data-backdrop="static"
                    data-keyboard="false"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered custom-popup" role="document">
                        <div className="modal-content   ">
                            <div className="modal-header">
                                <div className='social-header'>
                                    <h5 className="modal-title" id="exampleModalLabel">
                                        <img onClick={onGoBack} src={BackArrowWhite} alt="" />
                                        <span>Social Performance</span>
                                    </h5>

                                    {/* <div className='common-btn'>
                                        <a href={`${window.location.origin}/media-kit/${profileDetails?.cp_creators?.[0]?.userName_id}`} target="_blank">
                                            <button>Share Link</button>
                                            <img className='share-icon' src={shareIcon} alt="" />
                                        </a>
                                    </div> */}
                                </div>
                            </div>
                            <div className="modal-body ">
                                {showContent && <div className='user-profile-wrap'>
                                    <ImageLoader src={details?.actualAccount?.LogoURL} alt="" />
                                    <div className='user-name'>
                                        <h2>{details?.actualAccount?.PublisherName && JSON.parse('"' + String(JSON.parse('"' + details?.actualAccount?.PublisherName + '"')) + '"')}{details?.actualAccount?.DateOfBirth && (
                                            <span>
                                                (Age: {getYear(details?.actualAccount?.DateOfBirth)} {details?.actualAccount?.Gender})
                                            </span>
                                        )}</h2>
                                    </div>
                                    <div className='tags-description'>
                                        <div className='tag-container'>
                                            {!!details?.actualAccount?.Interests || !!details?.actualAccount?.Tags ? (
                                                <>
                                                    {tagsConcat(details?.actualAccount?.Interests, details?.actualAccount?.Tags)
                                                        ?.slice(0, 6)
                                                        .map((tag, tagIndex) => (
                                                            <span title={tag} key={tagIndex}>
                                                                {tag}
                                                            </span>
                                                        ))
                                                    }
                                                    {!!tagsConcat(details?.actualAccount?.Interests, details?.actualAccount?.Tags)?.slice(
                                                        6,
                                                        details?.actualAccount?.Interests?.length
                                                    ).length && <div className='more-btn'
                                                        aria-expanded="false"
                                                        aria-hidden="true"
                                                        id="service_dropdown"
                                                        data-toggle="dropdown"
                                                        aria-haspopup="true"

                                                    > {tagsConcat(details?.actualAccount?.Interests, details?.actualAccount?.Tags)
                                                        ?.length > 6
                                                        ? `+ ${tagsConcat(details?.actualAccount?.Interests, details?.actualAccount?.Tags)
                                                            .length - 6
                                                        } More`
                                                        : ""}
                                                            <div className="right-tooltip">
                                                                <div
                                                                    className="dropdown-menu"
                                                                    aria-labelledby="service_dropdown"
                                                                >
                                                                    <div className="dropdown-wrap-tool">
                                                                        {tagsConcat(details?.actualAccount?.Interests, details?.actualAccount?.Tags)
                                                                            ?.slice(
                                                                                6,

                                                                                tagsConcat(
                                                                                    details?.actualAccount?.Interests,
                                                                                    details?.actualAccount?.Tags
                                                                                )?.length
                                                                            )
                                                                            .map((tag, tagIndex) => (
                                                                                <a
                                                                                    key={tagIndex}
                                                                                    href="javascript:void(0);"
                                                                                >
                                                                                    {tag}
                                                                                </a>
                                                                            ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>}
                                                </>) : (
                                                <></>
                                            )}

                                        </div>
                                    </div>
                                    <div className="detail-description">
                                        <ShowMoreText
                                            lines={4}
                                            more="Know more"
                                            less="Show less"
                                            expanded={false}
                                            truncatedEndingComponent={"... "}
                                        >
                                            {(details?.actualAccount?.Description ? codeConvert(details?.actualAccount?.Description) : "")}
                                        </ShowMoreText>
                                    </div>
                                </div>
                                }
                                {showContent ? <>
                                    {details?.actualAccount?.Accounts &&
                                        <div className='connections-wrap'>
                                            <div className='row'>
                                                <div className='col-md-5'>
                                                    {!!Object.keys(details).length && (
                                                        <div className='connection-card'>
                                                            <h2>Connection Stats</h2>
                                                            <ul>
                                                                {details?.actualAccount?.Accounts?.map((account, index) => (
                                                                    <li key={index}>
                                                                        <a

                                                                            onClick={() => viewPublisher2(account)}
                                                                        >
                                                                            {socialSection(account, "view-details")}
                                                                        </a>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className='col-md-7 d-flex justify-content-center'>
                                                    <div className='graph-wrap d-flex align-items-center'>
                                                        {series.every(item => item === 0) ? <></> :
                                                            <Chart
                                                                options={options}
                                                                series={series}
                                                                type="donut"
                                                                width={250}
                                                                height={250}
                                                            />
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    <div className='react-tab-wrap'>
                                        <Tabs>
                                            <TabList>
                                                <Tab>Key Metrics</Tab>
                                                <Tab>Audience Details</Tab>
                                            </TabList>
                                            {!!Object.keys(details).length && (
                                                <>
                                                    <TabPanel>
                                                        <div>
                                                            {newDetails.map((account, index) => (
                                                                <div
                                                                    className={`tab-pane`}
                                                                    id="profile_tab1"
                                                                    role="tabpanel"
                                                                    aria-labelledby="audience1"
                                                                    key={index}
                                                                >
                                                                    <div className="social-details-wrap key-metrics-wrap">
                                                                        <div className="soical-user-info">
                                                                            <ul>
                                                                                <li>
                                                                                    <a href="javascript:void(0);"
                                                                                        onClick={() => viewPublisher3(account)}
                                                                                    >
                                                                                        {socialSectionMetric(account)}
                                                                                    </a>
                                                                                </li>
                                                                            </ul>
                                                                        </div>


                                                                        <div className="key-metrics-info-wrap">
                                                                            <div className="key-metric-card follow-data">
                                                                                {
                                                                                    firstHeadingTitle(account.Network)
                                                                                        .heading
                                                                                }
                                                                                <b>
                                                                                    {numberConversion(account.Followers) || "N/A"}
                                                                                </b>
                                                                            </div>
                                                                            <div className="key-metric-card">
                                                                                {
                                                                                    firstHeadingTitle(account.Network)
                                                                                        .heading
                                                                                }
                                                                                <b>
                                                                                    {numberConversion(account.Followers) || "N/A"}
                                                                                </b>
                                                                            </div>
                                                                            {engagementSection(account.EngagementFind)}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </TabPanel>
                                                    <TabPanel>
                                                        <div className='audience-details-wrap'>
                                                            {/* <AudienceDetails details={details?.actualAccount} /> */}

                                                            {!_.isEmpty(selectedOption) &&
                                                                <>
                                                                    <div className='audience-wrap'>
                                                                        <a href="#"><div className='social-icon'><img src={socialIcon1} alt="" /></div> <p>{selectedOption?.name} </p></a>
                                                                    </div>
                                                                    <div className='audience-social'>
                                                                        Active Audience: <span>{isNaN(parseFloat(activeAudience).toFixed(1)) ? 0 : parseFloat(activeAudience).toFixed(1) || 0}%</span> <div className='social-tooltip-wrap'
                                                                            aria-expanded="false"
                                                                            aria-hidden="true"
                                                                            id="service_dropdown"
                                                                            data-toggle="dropdown"
                                                                            aria-haspopup="true"

                                                                        >        <img src={Profile_tooltip} alt="" />
                                                                            <div className="right-tooltip">
                                                                                <div
                                                                                    className="dropdown-menu"
                                                                                    aria-labelledby="service_dropdown"
                                                                                >
                                                                                    <div className="dropdown-wrap-tool">
                                                                                        <p> This is an estimated percentage of the creator's active audience. It takes into account following posts, profile picture, bios, and follower to following ratio.
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div> </>}
                                                            <div className='graph-cards-wrap'>
                                                                <div className='row justify-content-around'>
                                                                    <div className='col-md-5'>
                                                                        <h2>Age</h2>
                                                                        <div className='graph-card'>
                                                                            <Chart
                                                                                options={options2}
                                                                                series={series2}
                                                                                type="bar"
                                                                                width={350}
                                                                                height={350}
                                                                            />
                                                                            {/* <img src={graphChart1} alt="" /> */}
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-md-5'>
                                                                        <h2 className='gender-graph'>Gender</h2>
                                                                        <div className='graph-card'>
                                                                            <Chart
                                                                                options={genderOptions}
                                                                                series={gender}
                                                                                type="pie"
                                                                                width={350}
                                                                                height={350}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-md-5 mx-auto mt-5'>
                                                                        <h2>Top Countries</h2>
                                                                        <div className='graph-card'>
                                                                            <Chart
                                                                                options={options3}
                                                                                series={series3}
                                                                                type="bar"
                                                                                width={350}
                                                                                height={350}
                                                                            />
                                                                            {/* <img src={graphChart1} alt="" /> */}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </TabPanel>
                                                </>
                                            )}
                                        </Tabs>
                                    </div>
                                </> : <div className="contentInfo">
                                    <img src={imgNoData} alt="" />
                                    {/* <span>Information not Available </span> */}
                                    {/* <p> creator has unlinked thier accounts</p>  */}
                                    <span>Oops! No account is linked</span>
                                    <p>Link your account to access performance insights</p>
                                    <div className='common-btn'>
                                        <button onClick={() => history.push("/account-authentication")} className="bg-btn"><img src={pinMark} alt="" /> Link Account</button>
                                    </div>
                                </div>}
                            </div>
                            {/* <div className="modal-footer">
                            <div className='common-btn'>
                                <button data-dismiss="modal">Okay</button>
                            </div>
                        </div> */}
                        </div>
                    </div>
                </div>
                {/* Social Performance Popup Start Here */}
                <div className='social-sidebar'>
                    <h2 className='social-header'>Get discovered for more
                        brand deals with Creator Pro</h2>
                    <OwlCarousel
                        className="owl-theme social-wrap-crousel"
                        loop={true}
                        margin={20}
                        nav={false}
                        autoWidth={false}
                        autoplay={true}
                        responsive={{
                            0: {
                                items: 1,

                            },
                            600: {
                                items: 1,

                            },
                            1000: {
                                items: 1,
                            },
                        }}
                    >
                        <div className="item">
                            <ul>
                                <li><img src={mediaKit1} alt="" /> <p>Media Kit</p>
                                    <span>Share your digital Media Kit including real time social metrics with brands</span> </li>
                            </ul>
                        </div>
                        <div className="item">
                            <ul>

                                <li><img src={mediaKit2} alt="" /> <p>Brand Yourself</p>
                                    <span>Highlight your performance on your social accounts to attract more collaboration opportunities</span> </li>

                            </ul>
                        </div>
                        <div className="item">
                            <ul>

                                <li><img src={mediaKit3} alt="" /> <p>Track Social Performance</p>
                                    <span>Easily monitor your performance across Instagram, YouTube, Facebook etc., at one place</span> </li>
                            </ul>
                        </div>
                    </OwlCarousel>
                    <ul className='media-kit-desktop'>
                        <li><img src={mediaKit1} alt="" /> <p>Media Kit</p>
                            <span>Share your digital Media Kit including real time social metrics with brands</span> </li>
                        <li><img src={mediaKit2} alt="" /> <p>Brand Yourself</p>
                            <span>Highlight your performance on your social accounts to attract more collaboration opportunities</span> </li>
                        <li><img src={mediaKit3} alt="" /> <p>Track Social Performance</p>
                            <span>Easily monitor your performance across Instagram, YouTube, Facebook etc., at one place</span> </li>
                    </ul>
                    <div className={`generatelink-wrap ${!showContent && "pointer-none"}`}>
                        <input className='form-control' value={profileDetails?.cp_creators?.[0]?.publisher_id && `${window.location.origin}/media-kit/${profileDetails.cp_creators[0].userName_id}`} placeholder='Generate link to share' type="text" />
                        <div className='common-btn'>
                            <button type="button" className={`${!showContent && "btn-disable"}`} onClick={onCopyLink}>Copy Link</button>
                        </div>
                    </div>
                    {showContent && <div className={`via-share-options ${!showContent && "pointer-none"}`}>
                        <p>or share via</p>
                        <ul>
                            <li>
                                <a>
                                    <FacebookShareButton id="whatsapp-share" className='whatsapp-share' url={`${window.location.origin}/media-kit/${profileDetails?.cp_creators?.[0]?.userName_id}`}>
                                        <img src={shareFacebook} alt="" />
                                    </FacebookShareButton>
                                </a>
                            </li>
                            {/* <li>
                                <a>
                                    <FacebookShareButton id="whatsapp-share" className='whatsapp-share' url={`${window.location.origin}/media-kit/${profileDetails?.cp_creators?.[0]?.userName_id}`}>
                                        <img src={shareInstagram} alt="" />
                                    </FacebookShareButton>
                                </a>
                            </li> */}
                            <li>
                                <a>
                                    <WhatsappShareButton id="whatsapp-share" className='whatsapp-share' url={`${window.location.origin}/media-kit/${profileDetails?.cp_creators?.[0]?.userName_id}`}>
                                        <img src={shareWhatsupfrom} alt="" />
                                    </WhatsappShareButton>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <TwitterShareButton id="whatsapp-share" className='whatsapp-share' url={`${window.location.origin}/media-kit/${profileDetails?.cp_creators?.[0]?.userName_id}`}>
                                        <img src={shareTwitter} alt="" />
                                    </TwitterShareButton>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <EmailShareButton id="whatsapp-share" className='whatsapp-share' url={`${window.location.origin}/media-kit/${profileDetails?.cp_creators?.[0]?.userName_id}`}>
                                        <img src={shareGmail} alt="" />
                                    </EmailShareButton>
                                </a>
                            </li>
                        </ul>
                    </div>}
                    <div className={`common-btn share-btn ${!showContent && "pointer-none"}`}>
                        <RWebShare
                            data={{
                                text: `Checkout my media kit `,
                                url: `${window.location.origin}/media-kit/${profileDetails?.cp_creators?.[0]?.userName_id}`,
                            }}
                        >
                            <button className={`${!showContent && "btn-disable"}`} type="button">Share Media Kit</button>
                        </RWebShare>
                    </div>
                </div>

            </div>
            {/* <div className='josh-footer-wrap'>
                    <span> Powered by</span>
                    <img src={footerLogo} alt="" />
                </div> */}
        </>
    )
}

export default IsLoadingHOC(SocialPerformance)
